var utils = require('lib/utils');
var SessionService = function() {
  if (SessionService.prototype._singleton){
    return SessionService.prototype._singleton;
  }

  SessionService.prototype._singleton = this;

  var tryParseJson = function(value) {
    var result;
    try {
      result = JSON.parse(value);
    } catch(e) {
      result = value;
    }
    return result;
  };

  this.get = function(key) {
    return tryParseJson(sessionStorage.getItem(key));
  };

  this.getByDotString = function(dotString){
    let rawData = dotString.split('.');
    let key = rawData.shift();
    let sessionObject = this.get(key);

    if (sessionObject) {
      return rawData.length === 0 ? sessionObject : utils.dotStringToObject(rawData.join('.'), sessionObject);
    }
  };

  this.set = function(key, item) {
    if(key === undefined) {
      throw new Error("Cannot store an item in session with an undefined key.");
    }
    if(typeof item === 'object') {
      sessionStorage.setItem(key, JSON.stringify(item));
    } else {
      sessionStorage.setItem(key, item);
    }
  };

  this.remove = function(key) {
    sessionStorage.removeItem(key);
  };

  /* Returns key/value pair object that maps to sessionStorage */
  this.getAll = function() {
    return Object.keys(sessionStorage).reduce(function(result, key) {
      if(key !== undefined) {
        result[key] = tryParseJson(sessionStorage.getItem(key));
        return result;
      }
    }, {});
  };

  this.clear = function() {
    sessionStorage.clear();
  };
};

var sessionService = new SessionService();

module.exports = sessionService;
